<script lang="ts">
    import { computed, onMounted, onUnmounted, Ref, ref, toRaw } from 'vue';

    import vm, { JourneyLine, LineType } from '@journeys/Journeys.viewmodel';

    // directives
    import { vTooltip } from '@shared/directives';

    // components
    import FluidButton from '@cwd/shared/components/FluidButton.vue';

    // assets
    import { LineTypeSVG } from '@shared/assets/vector/ui/IconsUI';
    import PresetColors from '@shared/components/ColorPickers/PresetColors';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'LineContextMenu',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const props = defineProps<{
        data: JourneyLine;
        colors: any;
    }>();

    // onUnmounted(() => {
    // console.log('unmounted')
    // editor.events.emit('opencontextmenu', )
    // })

    const selectType = (type: LineType) => {
        props.data.t = type;
    };

    const selectColor = (clr: number) => {
        props.data.c = clr;
    };
</script>

<template>
    <div class="line-menu">
        <div class="fl" style="gap: 2px">
            <FluidButton
                class="btn btn-default btn-sm"
                :icon="LineTypeSVG"
                :class="data.t === LineType.Solid && 'active'"
                :iconProps="{ type: LineType.Solid }"
                @click="() => selectType(LineType.Solid)" />

            <FluidButton
                class="btn btn-default btn-sm"
                :icon="LineTypeSVG"
                :class="data.t === LineType.Dashed && 'active'"
                :iconProps="{ type: LineType.Dashed }"
                @click="() => selectType(LineType.Dashed)" />

            <FluidButton
                class="btn btn-default btn-sm"
                :icon="LineTypeSVG"
                :class="data.t === LineType.Dotted && 'active'"
                :iconProps="{ type: LineType.Dotted }"
                @click="() => selectType(LineType.Dotted)" />
        </div>

        <div class="separator horizontal"></div>

        <div class="line-swatches-container">
            <div
                class="line-swatch-cell"
                v-for="{ clr, tooltip } in colors"
                :style="[`background-color: ${PresetColors[clr].hsl}`]"
                @click="selectColor(clr)"></div>
        </div>
    </div>
</template>

<style>
    .line-menu {
        position: relative;
    }

    .line-menu .fluid-button {
        height: 1.6rem;
        width: 1.6rem;
    }

    .line-menu svg {
        height: 1rem;
        width: 1rem;
    }

    .line-swatches-container {
        position: relative;
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .line-swatch-cell {
        height: 18px;
        width: 18px;
        border-radius: 2px;

        cursor: pointer;
    }

    .line-menu .separator.horizontal {
        width: 90%;
        margin: 0.2rem auto;
    }
</style>
